import { useMemo } from 'react'
import { useOrgParams } from '~/common/use-org-params'
import { useSeasonList } from './use-season-list'

/**
 * Returns true when the currently selected season (from URL) is ended.
 * Returns false when no season is selected or the season is active.
 */
export const useIsSeasonReadOnly = () => {
  const { farmId, seasonId } = useOrgParams()
  const { seasons } = useSeasonList({ farmId })

  return useMemo(() => {
    if (!seasonId || !seasons.length) return false
    const season = seasons.find(s => s.id === seasonId)
    return season?.state === 'ended'
  }, [seasonId, seasons])
}
